import React from "react";
import "./Privacy.css";
import Footer from "./Footer";
import { Link } from "react-router-dom";

const Privacy = () => {
  return (
    <div className="page-wrapper">
      <main className="privacy-container">
        <div className="privacy-content">
          <h1 className="privacy-title">Privacy & Policy</h1>
          <p className="privacy-effective-date">
            <strong>Effective Date:</strong> 08-25-24
          </p>

          <div className="privacy-intro">
            <p>
              Attoli ("we," "our," or "us") respects your privacy and is
              committed to protecting any personal information you may share
              with us. This Privacy Policy explains what information we collect,
              how we use it, and the choices you have.
            </p>
          </div>

          <section className="privacy-section">
            <h2>1. Information We Collect</h2>
            <p>
              We may collect the following types of information when you
              interact with our website:
            </p>
            <ul>
              <li>
                <strong>Contact Information:</strong> If you choose to contact
                us through a form or by email, we may collect your name, email
                address, and any other information you choose to provide.
              </li>
              <li>
                <strong>Email Subscriptions:</strong> If you sign up to receive
                updates or newsletters (planned for the future), we will collect
                and store your email address with your consent.
              </li>
              <li>
                <strong>Technical Data:</strong> Our hosting provider (Vercel)
                automatically collects limited technical information such as IP
                addresses and browser type for security and site performance
                purposes.
              </li>
              <li>
                <strong>Social Media Features:</strong> Our website may include
                social media sharing buttons (e.g., Facebook, Instagram,
                X/Twitter). These features may collect information such as your
                IP address or set cookies when you interact with them. Please
                see the privacy policies of those platforms for details.
              </li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>2. How We Use Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Respond to inquiries about our SEO services.</li>
              <li>Provide updates or newsletters if you have subscribed.</li>
              <li>Maintain the security and performance of our website.</li>
              <li>Improve how we present our portfolio and services online.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>3. Sharing of Information</h2>
            <p>
              We do <strong>not</strong> sell, rent, or trade your personal
              information.
            </p>
            <p>We may share information only in these limited circumstances:</p>
            <ul>
              <li>
                <strong>Service Providers:</strong> Our hosting provider
                (Vercel) processes technical data for site hosting and security.
              </li>
              <li>
                <strong>Social Platforms:</strong> If you use social sharing
                buttons, those platforms may receive data in accordance with
                their own privacy policies.
              </li>
              <li>
                <strong>Legal Requirements:</strong> We may disclose information
                if required by law or to protect our rights.
              </li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>4. Data Retention</h2>
            <p>
              We retain personal information only as long as necessary to
              fulfill the purposes described in this policy (for example, until
              we've responded to your inquiry).
            </p>
          </section>

          <section className="privacy-section">
            <h2>5. Security</h2>
            <p>
              We take reasonable measures to protect personal information,
              including using SSL encryption and relying on Vercel's secure
              hosting infrastructure. However, no method of transmission over
              the internet is 100% secure, and we cannot guarantee absolute
              security.
            </p>
          </section>

          <section className="privacy-section">
            <h2>6. Your Rights</h2>
            <p>Depending on where you live, you may have rights to:</p>
            <ul>
              <li>
                Request access to the personal information we hold about you.
              </li>
              <li>Request correction or deletion of your information.</li>
              <li>Withdraw consent for receiving updates or newsletters.</li>
            </ul>
            <p>
              To exercise these rights, please contact us at the email below.
            </p>
          </section>

          <section className="privacy-section">
            <h2>7. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes
              will be posted on this page with an updated "Effective Date."
            </p>
          </section>

          <section className="privacy-section">
            <h2>8. Contact Us</h2>
            <p>
              If you have any questions or concerns about this Privacy Policy,
              please contact us:
            </p>
            <p className="contact-email-pp">📧 attoli@outlook.com</p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Privacy;
